import Swiper, { Navigation, Keyboard, A11y } from 'swiper';
import gsap from 'gsap';
import SplitText from '../vendor/gsap/SplitText';
import mobile from 'is-mobile';
import WebFont from "webfontloader";

class Testimonials {
  constructor() {
    const testimonialSliders = window.wrapper.querySelectorAll('.testimonials-simple__slider');
    const preloadFonts = () => new Promise((resolve) => {
      WebFont.load({
        custom: {
          families: ['TT Commons'],
        },
        active: resolve
      });
    });

    Promise.all([preloadFonts()]).then(() => {
      [].forEach.call(testimonialSliders, (slider) => {
        Testimonials.initSlider(slider)
      });
    });
  }

  static initSlider(slider) {
    const slides = slider.querySelectorAll('.swiper-slide');

    if(slides.length < 2){
      return;
    }

    this.textSplitted = new SplitText(slider.querySelectorAll('.testimonials-simple__text'), {
      type: 'lines',
      linesClass: 'lines',
    });

    const lines = slider.querySelectorAll('.swiper-slide:not(:first-child) .lines');
    gsap.set(lines, {
      autoAlpha: 0,
      y: 20,
      force3D: true
    });

    const { id } = slider.dataset;
    const nextEl = slider.querySelector(`[data-prev="${id}"]`);
    const prevEl = slider.querySelector(`[data-next="${id}"]`);
    return new Swiper(slider, {
      modules: [Navigation, Keyboard, A11y],
      effect: 'customTransition',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove : false,
      speed: 0,
      autoHeight: true,
      watchSlidesProgress: true,
      virtualTranslate: true,
      navigation: {
        nextEl,
        prevEl,
        disabledClass: 'testimonials-simple__slider__disabled',
        hiddenClass: 'testimonials-simple__slider__hidden'
      },
      breakpoints: {
        768: {
          loop: false,
          allowTouchMove: false
        }
      },
      on: {
        setTranslate(swiper, translate) {
          const slides = Object.values(swiper.slides);
          slides.map((slide) => {
            // to put the slides behind each other we have to set their CSS translate accordingly since by default they are arranged in line.
            const offset = slide.swiperSlideOffset;
            let x = -offset;
            if (!swiper.params.virtualTranslate) x -= translate;
            let y = 0;
            if (!swiper.isHorizontal()) {
              y = x;
              x = 0;
            }
            gsap.set(slide, {
              x,
              y
            });
          });
        },
        click(swiper, event) {
          if(event.target.classList.contains('testimonials-simple__slider__next')
            && ((swiper.activeIndex + 1) === slides.length)) {
            swiper.slideTo(0);
          }
        },
        beforeSlideChangeStart(swiper){
          const activeSlide = slides[swiper.activeIndex];
          const oldLines = [...activeSlide.getElementsByClassName('lines')];
          const delay = oldLines.length * 0.05 + 0.2;
          swiper.wrapperEl.style.transitionDelay = `${delay}s`;
        },
        slideChangeTransitionStart(swiper) {
          prevEl.style.pointerEvents = 'none';
          nextEl.style.pointerEvents = 'none';
          const previousSlide = slides[swiper.previousIndex];
          const activeSlide = slides[swiper.activeIndex];
          const oldLines = [...previousSlide.getElementsByClassName('lines')];
          const newLines = [...activeSlide.getElementsByClassName('lines')];
          const tl = gsap.timeline({paused: true});

          tl.to(oldLines, {
            autoAlpha: 0,
            stagger: 0.05,
            duration: 0.2
          });

          tl.set(oldLines, {
            y: 20,
            autoAlpha: 0,
            force3D: true
          });

          // if mobile and last slide then just hide last slide lines
          if(mobile() && (swiper.previousIndex > swiper.activeIndex)){
            tl.play();
            return;
          }

          tl.to(newLines, {
            autoAlpha: 1,
            y: '-=20',
            stagger: 0.06,
            duration: 0.4
          }, '-=0.2');

          tl.play();
        },
        slideChangeTransitionEnd(swiper) {
          const activeSlide = slides[swiper.activeIndex];
          const newLines = [...activeSlide.getElementsByClassName('lines')];

          setTimeout(() => {
            prevEl.style.pointerEvents = '';
            nextEl.style.pointerEvents = '';
          }, newLines.length * 50 + 200);
        }
      }
    });
  }
}

export default Testimonials;
